import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePreClaimsPercentageOrValueList } from './normalize';

export const fetchPreClaimsPercentageOrValueList = createProvider(api.fetchPreClaimsPercentageOrValueList)
  .andThen((res) => normalizePreClaimsPercentageOrValueList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
